import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { Globals } from '../_globals';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { OrdersService } from 'app/_services/orders.service';
import { ProductsService } from 'app/_services/products.service';
import { ReportingService } from 'app/_services/reporting.service';

import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-reporting',
    templateUrl: './reporting.component.html',
    styleUrls: ['./reporting.component.css'],
})
export class ReportingComponent implements OnInit {
    role: any;
    routeRole: any;
    cookieStore: any;

    endOfDayStart = new Date();
    endOfDayEnd = new Date();

    promoStart = new Date();
    promoEnd = new Date();

    endOfDayReportForm: FormGroup;
    promoReportForm: FormGroup;

    constructor(
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _ordersService: OrdersService,
        public _productsService: ProductsService,
        public _reportingService: ReportingService,
        public fb: FormBuilder
    ) {
        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.endOfDayStart.setHours(7);
        this.endOfDayStart.setMinutes(0);
        this.endOfDayStart.setSeconds(0), this.endOfDayStart.setMilliseconds(0);
        this.endOfDayEnd.setHours(23);
        this.endOfDayEnd.setMinutes(0);
        this.endOfDayEnd.setSeconds(0), this.endOfDayEnd.setMilliseconds(0);

        this.promoStart.setMonth(this.promoStart.getMonth() - 1);
        this.promoStart.setHours(6);
        this.promoStart.setMinutes(0);
        this.promoStart.setSeconds(0), this.promoStart.setMilliseconds(0);

        this.promoEnd.setHours(6);
        this.promoEnd.setMinutes(0);
        this.promoEnd.setSeconds(0), this.promoEnd.setMilliseconds(0);



        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            // console.log('this.cookieStore', this.cookieStore);
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }

        this.endOfDayReportForm = fb.group({
            date: new FormControl(new Date(), [Validators.required]),
            startTime: new FormControl(this.endOfDayStart, [Validators.required]),
            endTime: new FormControl(this.endOfDayEnd, [Validators.required]),
        });

        this.promoReportForm = fb.group({
            start: new FormControl(this.promoStart, [Validators.required]),
            end: new FormControl(this.promoEnd, [Validators.required]),
            amount: new FormControl(200, [Validators.required]),
        });


    }

    ngOnInit() {
        // console.log(pdfMake);
    }

    outOfStockReport() {
        let products = [];
        this._productsService
            .getAllProductsByStoreIdChunked(this.cookieStore.id)
            .subscribe((dataArray: any) => {
                let dataLength = dataArray[0].length;

                dataArray[0].forEach((element) => {
                    // Only add element to products if they are enabled
                    if(element.enabled === true) {
                        products = products.concat(element);
                    }
                    
                    dataLength--;
                    const today = new Date();

                    const header = 'Out of Stock Report';
                    const subheader =
                        'Out of Stock Products on ' + formatDate(today, 'EE dd/MM/yyyy h:mm a', 'en');

                    if (!products.length) {
                        alert('There are no products out of stock');
                    } else if (dataLength === 0) {
                        // console.log('***create report');
                        this.createOutOfStockReport(this.cookieStore, header, subheader, products);
                    }
                });
            });
    }



    promoReportFormSubmit() {


        const storeId = this.cookieStore.id;

        const values = this.promoReportForm.value;


        const startOffset = values.start.getTimezoneOffset() * 60000; // offset in milliseconds
        const endOffset = values.end.getTimezoneOffset() * 60000; // offset in milliseconds

        const start = values.start.getTime() - startOffset;
        const end = values.end.getTime() - endOffset;


        // console.log('start', start);
        // console.log('end', end);
        // console.log('amount', values.amount);
        // console.log('storeId', storeId);


        this._reportingService
            .getPromoReport(storeId, values.amount, start, end)
            .subscribe((data: any) => {

                // console.log('getPromoReport', data);

                const header = 'Promotional Report';
                const subheader = `${formatDate(data.startDate, 'EE dd/MM/yyyy h:mm a', 'en', 'UTC')} - ${formatDate(data.endDate, 'EE dd/MM/yyyy h:mm a', 'en', 'UTC')}`;

                if (!data.users.length) {
                    alert(`No customers have spent over ${data.store.currency}${data.amount} between these dates`);
                } else {
                    // console.log('***create promo report');
                    this.createPromoReport(data.store, header, subheader, data.amount, data.users);
                }

            });



    }


    createPromoReport(store, header, subheader, amount, customers) {

        let storeString = store.name;
        if (store.address1) {
            storeString += ', ' + store.address1;
        }
        if (store.address2) {
            storeString += ', ' + store.address2;
        }
        if (store.city) {
            storeString += ', ' + store.city;
        }


        const documentDefinition: any = {
            content: [
                {
                    text: subheader,
                    style: 'topheader',
                },
                {
                    text: header,
                    style: 'header1',
                },
                {
                    text: storeString,
                    style: 'subheader',
                },
                '\n\n',
            ],
            styles: {
                header1: {
                    fontSize: 20,
                    lineHeight: 1,
                    bold: true,
                },
                header2: {
                    fontSize: 14,
                    lineHeight: 1,
                    bold: true,
                },
                topheader: {
                    fontSize: 11,
                    lineHeight: 2,
                    bold: true,
                    color: '#ababab',
                },
                subheader: {
                    fontSize: 11,
                    bold: false,
                    color: '#ababab',
                },
                quote: {
                    italics: true,
                },
                small: {
                    fontSize: 8,
                },
                tableStandard: {
                    margin: [0, 5, 0, 15],
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                },
                tableSmall: {
                    margin: [0, 5, 0, 15],
                    fontSize: 9,
                },
                tableHeaderSmall: {
                    bold: true,
                    fontSize: 9,
                    color: 'black',
                },
            },
        };


        const customerContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'Name', style: 'tableHeaderSmall' },
                        { text: 'Email', style: 'tableHeaderSmall' },
                        { text: 'Phone', style: 'tableHeaderSmall' },
                        { text: 'Total Spend', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        customers.forEach((element) => {
            const item = [
                `${element.firstName} ${element.lastName}`,
                `${element.email}`,
                `${element.phoneNumber}`,
                `${store.currency} ${element.amount}`,
            ];


            customerContent.table.body.push(item);
        });


        if (customerContent.table.body.length > 1) {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: `Customers spending over ${store.currency}${amount} (${customerContent.table.body.length - 1})`,
                style: 'header2',
            });
            documentDefinition.content.push(customerContent);
        }



        pdfMake.createPdf(documentDefinition).download(header + ' - ' + store.name + ' - ' + subheader);

    }


    endOfDayReportFormSubmit() {
        let dayInc = 0;

        const values = this.endOfDayReportForm.value;
        // console.log('endOfDayReportForm', values);


        if (values.endTime < values.startTime) {
            // console.log('** END TIME IS NEXT DAY');
            dayInc = 1;
        }

        const start = new Date(
            values.date.getFullYear(),
            values.date.getMonth(),
            values.date.getDate(),
            values.startTime.getHours(),
            values.startTime.getMinutes(),
            0,
            0
        );

        const startOffset = start.getTimezoneOffset() * 60000; // offset in milliseconds

        const end = new Date(
            values.date.getFullYear(),
            values.date.getMonth(),
            values.date.getDate() + dayInc,
            values.endTime.getHours(),
            values.endTime.getMinutes(),
            0,
            0
        );

        const endOffset = start.getTimezoneOffset() * 60000; // offset in milliseconds

        const body = {
            storeId: this.cookieStore.id,
            startDate: start,
            endDate: end,
            startMilli: start.getTime() - startOffset - 1,
            endMilli: end.getTime() - endOffset,
        };

        this._ordersService
            .getPurchasesForStoreBetweenDates(body.storeId, body.startMilli, body.endMilli)
            .subscribe((data: any) => {
                const report = {
                    orders: [],
                    totalPrePay: 0,
                    totalCash: 0,
                    totalValue: 0,
                };

                data.body.forEach((element) => {
                    if (element.purcahaseStatus === 'COMPLETED') {
                        let workplace = null;
                        let prePay = false;

                        if (element.workplaceSlot) {
                            workplace = {
                                id: element.workplaceSlot.workplace.id,
                                identifier: element.workplaceSlot.workplace.identifier,
                                name: element.workplaceSlot.workplace.name,
                                telephone: element.workplaceSlot.workplace.telephone,
                                slotName: element.workplaceSlot.name,
                            };
                        }

                        if (element.charge && element.charge.chargeStatus === 'PAID') {
                            prePay = true;
                        }

                        const order = {
                            id: element.id,
                            prePay: prePay,
                            due: element.due,
                            orderTime: element.orderTime,
                            purcahaseStatus: element.purcahaseStatus,
                            purchaseItems: element.purchaseItems,
                            purchaseType: element.purchaseType,
                            totalPrice: element.totalPrice,
                            workplace: workplace,
                        };

                        report.orders.push(order);
                        report.totalValue += element.totalPrice;
                        if (prePay) {
                            report.totalPrePay += element.totalPrice;
                        } else {
                            report.totalCash += element.totalPrice;
                        }
                    }
                });

                // console.log(data.body);
                // console.log('Order Count: ', data.body.length);
                // console.log('Report Count: ', report.orders.length);
                // console.log(report);

                const header = 'End Of Day Report';
                const subheader =
                    formatDate(body.startDate, 'EE dd/MM/yyyy h:mm a', 'en') +
                    ' - ' +
                    formatDate(body.endDate, 'EE dd/MM/yyyy h:mm a', 'en');

                if (!report.orders.length) {
                    alert('There is no data for this time period');
                } else {
                    this.createEndOfDayReport(this.cookieStore, header, subheader, report);
                }
            });
    }

    createEndOfDayReport(store, header, subheader, report) {
        let storeString = store.name;
        if (store.address1) {
            storeString += ', ' + store.address1;
        }
        if (store.address2) {
            storeString += ', ' + store.address2;
        }
        if (store.city) {
            storeString += ', ' + store.city;
        }

        const prePayContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'ID', style: 'tableHeaderSmall' },
                        { text: 'Order Time', style: 'tableHeaderSmall' },
                        { text: 'Due Time', style: 'tableHeaderSmall' },
                        { text: 'Type', style: 'tableHeaderSmall' },
                        { text: 'Total', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        const cashContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'ID', style: 'tableHeaderSmall' },
                        { text: 'Order Time', style: 'tableHeaderSmall' },
                        { text: 'Due Time', style: 'tableHeaderSmall' },
                        { text: 'Type', style: 'tableHeaderSmall' },
                        { text: 'Total', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        const groupContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'ID', style: 'tableHeaderSmall' },
                        { text: 'Order Time', style: 'tableHeaderSmall' },
                        { text: 'Due Time', style: 'tableHeaderSmall' },
                        { text: 'Type', style: 'tableHeaderSmall' },
                        { text: 'Total', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        report.orders.forEach((element) => {
            const item = [
                element.id,
                formatDate(element.orderTime, 'yyyy-MM-dd HH:mm', 'en'),
                formatDate(element.due, 'yyyy-MM-dd HH:mm', 'en'),
                element.purchaseType,
                this.cookieStore.currency + ' ' + element.totalPrice,
            ];

            if (element.purchaseType === 'GROUP') {
                groupContent.table.body.push(item);
            } else if (element.prePay) {
                prePayContent.table.body.push(item);
            } else {
                cashContent.table.body.push(item);
            }
        });

        const documentDefinition: any = {
            content: [
                {
                    text: subheader,
                    style: 'topheader',
                },
                {
                    text: header,
                    style: 'header1',
                },
                {
                    text: storeString,
                    style: 'subheader',
                },
                '\n\n',
                {
                    style: 'tableStandard',
                    table: {
                        widths: ['*', '*', '*', '*'],
                        body: [
                            [
                                { text: 'Total Orders', style: 'tableHeader' },
                                { text: 'Total Cash', style: 'tableHeader' },
                                { text: 'Total Pre-Pay', style: 'tableHeader' },
                                { text: 'Total Value', style: 'tableHeader' },
                            ],
                            [
                                report.orders.length,
                                this.cookieStore.currency + ' ' + report.totalCash.toFixed(2),
                                this.cookieStore.currency + ' ' + report.totalPrePay.toFixed(2),
                                this.cookieStore.currency + ' ' + report.totalValue.toFixed(2),
                            ],
                        ],
                    },
                },
            ],
            styles: {
                header1: {
                    fontSize: 20,
                    lineHeight: 1,
                    bold: true,
                },
                header2: {
                    fontSize: 14,
                    lineHeight: 1,
                    bold: true,
                },
                topheader: {
                    fontSize: 11,
                    lineHeight: 2,
                    bold: true,
                    color: '#ababab',
                },
                subheader: {
                    fontSize: 11,
                    bold: false,
                    color: '#ababab',
                },
                quote: {
                    italics: true,
                },
                small: {
                    fontSize: 8,
                },
                tableStandard: {
                    margin: [0, 5, 0, 15],
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                },
                tableSmall: {
                    margin: [0, 5, 0, 15],
                    fontSize: 9,
                },
                tableHeaderSmall: {
                    bold: true,
                    fontSize: 9,
                    color: 'black',
                },
            },
        };

        if (cashContent.table.body.length > 1) {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: 'Cash Orders (' + (cashContent.table.body.length - 1) + ')',
                style: 'header2',
            });
            documentDefinition.content.push(cashContent);
        }

        if (prePayContent.table.body.length > 1) {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: 'Pre-Pay Orders (' + (prePayContent.table.body.length - 1) + ')',
                style: 'header2',
            });
            documentDefinition.content.push(prePayContent);
        }

        if (groupContent.table.body.length > 1) {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: 'Pre-Pay Group Orders (' + (groupContent.table.body.length - 1) + ')',
                style: 'header2',
            });
            documentDefinition.content.push(groupContent);
        }

        pdfMake.createPdf(documentDefinition).download(header + ' - ' + store.name + ' - ' + subheader);
    }

    createOutOfStockReport(store, header, subheader, products) {
        // console.log('createOutOfStockReport', products);

        let storeString = store.name;
        if (store.address1) {
            storeString += ', ' + store.address1;
        }
        if (store.address2) {
            storeString += ', ' + store.address2;
        }
        if (store.city) {
            storeString += ', ' + store.city;
        }

        const inStockContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'ID', style: 'tableHeaderSmall' },
                        { text: 'Name', style: 'tableHeaderSmall' },
                        { text: 'Ean', style: 'tableHeaderSmall' },
                        { text: 'Stock', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        const outOfStockContent: any = {
            style: 'tableSmall',
            table: {
                widths: ['auto', '*', '*', 'auto'],
                body: [
                    [
                        { text: 'ID', style: 'tableHeaderSmall' },
                        { text: 'Name', style: 'tableHeaderSmall' },
                        { text: 'Ean', style: 'tableHeaderSmall' },
                        { text: 'Stock', style: 'tableHeaderSmall' },
                    ],
                ],
            },
        };

        products.forEach((element) => {
            const item = [element.id, element.displayName, element.ean, element.stock];

            if (element.inStock) {
                inStockContent.table.body.push(item);
            } else {
                outOfStockContent.table.body.push(item);
            }
        });

        const documentDefinition: any = {
            content: [
                {
                    text: subheader,
                    style: 'topheader',
                },
                {
                    text: header,
                    style: 'header1',
                },
                {
                    text: storeString,
                    style: 'subheader',
                },
                '\n\n',
            ],
            styles: {
                header1: {
                    fontSize: 20,
                    lineHeight: 1,
                    bold: true,
                },
                header2: {
                    fontSize: 14,
                    lineHeight: 1,
                    bold: true,
                },
                topheader: {
                    fontSize: 11,
                    lineHeight: 2,
                    bold: true,
                    color: '#ababab',
                },
                subheader: {
                    fontSize: 11,
                    bold: false,
                    color: '#ababab',
                },
                quote: {
                    italics: true,
                },
                small: {
                    fontSize: 8,
                },
                tableStandard: {
                    margin: [0, 5, 0, 15],
                },
                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black',
                },
                tableSmall: {
                    margin: [0, 5, 0, 15],
                    fontSize: 9,
                },
                tableHeaderSmall: {
                    bold: true,
                    fontSize: 9,
                    color: 'black',
                },
            },
        };

        // console.log('inStockContent', inStockContent);
        // console.log('outOfStockContent', outOfStockContent);

        // if (inStockContent.table.body.length > 1) {
        //   documentDefinition.content.push('\n');
        //   documentDefinition.content.push({
        //     text: 'In Stock Products (' + (inStockContent.table.body.length - 1) + ')',
        //     style: 'header2',
        //   });
        //   documentDefinition.content.push(inStockContent);
        // } else {
        //   documentDefinition.content.push('\n');
        //   documentDefinition.content.push({
        //     text: 'No Products Are In Stock',
        //     style: 'header2',
        //   });
        // }

        if (outOfStockContent.table.body.length > 1) {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: 'Out Of Stock Products (' + (outOfStockContent.table.body.length - 1) + ')',
                style: 'header2',
            });
            documentDefinition.content.push(outOfStockContent);
        } else {
            documentDefinition.content.push('\n');
            documentDefinition.content.push({
                text: 'No Products Are Out Of Stock',
                style: 'header2',
            });
        }

        pdfMake.createPdf(documentDefinition).download(header + ' - ' + store.name + ' - ' + subheader);
    }
}



// WEBPACK FOOTER //
// ./src/app/reporting/reporting.component.ts